import React from 'react';
import { US_STATES } from '../model/stateData';
import { MapPin, Globe } from 'lucide-react';
import './StateSelector.css';

export default function StateSelector({ selectedState, onSelect }) {
    return (
        <div className="state-selector-container">
            <div className="selector-label">
                <MapPin size={14} className="selector-icon" />
                <span>Geographic Scope</span>
            </div>

            <select
                className="state-dropdown"
                value={selectedState || 'US'}
                onChange={(e) => onSelect(e.target.value === 'US' ? null : e.target.value)}
            >
                {US_STATES.map(state => (
                    <option key={state.code} value={state.code}>
                        {state.name}
                    </option>
                ))}
            </select>

            <div className="selector-status">
                {selectedState ? (
                    <span className="status-badge state-badge">
                        State-Level Mode: {selectedState}
                    </span>
                ) : (
                    <span className="status-badge national-badge">
                        <Globe size={11} style={{ marginRight: '4px' }} />
                        National Aggregate
                    </span>
                )}
            </div>
        </div>
    );
}
